import React, { lazy } from "react";
import Page from "../components/Page";

// const HealthCheckMF = lazy(() => import("@SupportTS/Diagnostics")); 
const HealthCheckMF = lazy(() => import("@SupportTS/HealthCheck")); 

const HealthCheck = () => {
  return (
    <Page>
      <HealthCheckMF />
    </Page>
  );
};

export default HealthCheck;
